import { call, select } from 'redux-saga/effects';
import { CANCEL, SagaIterator } from 'redux-saga';
import type { API_RESPONSE } from '@corefront/eva-fe-sdk';
import { initAPI, getAPI } from '../../../services/API';
import { proxyPrefixSelector } from '../../reducers/app/params';
import { COMMON_CONFIG_URL } from '../../../constants/api';

export function* initializeAPI() {
  const proxyPrefix: ReturnType<typeof proxyPrefixSelector> = yield select(
    proxyPrefixSelector
  );

  yield call(initAPI, { baseUrl: proxyPrefix });
}

export function* getCommonConfiguration(): SagaIterator<
  API_RESPONSE.CommonConfig['200']
> {
  const { fetch } = getAPI();

  return yield call(fetch, COMMON_CONFIG_URL, { abortMethodName: CANCEL });
}
